"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = get;
exports.post = post;
exports.put = put;
exports.del = del;
exports.head = head;
exports.patch = patch;
const utils_1 = require("@aws-amplify/core/internals/utils");
const publicApis_1 = require("./common/publicApis");
function get(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.get)(ctx, input);
}
function post(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.post)(ctx, input);
}
function put(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.put)(ctx, input);
}
function del(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.del)(ctx, input);
}
function head(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.head)(ctx, input);
}
function patch(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, publicApis_1.patch)(ctx, input);
}
